import { BrowserRouter, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './resources/css/icons.css';
import './resources/css/style.css';
import './resources/css/custom-ypf.css';
import './resources/css/custom.css';

import { useEffect } from 'react';
import { AppRutas } from './router/appRoutes';
import { UserRutas } from './router/userRoutes';
import {
  AuthProvider,
  useAuthContext,
} from './context/Auth/AuthProvider';
import { HeaderComponent } from './modules/Home/Header';
import { FooterComponent } from './modules/Home/Footer';
import { AccesoDenegado } from './modules/Error/AccesoDenegado';

function AppContent() {
  const { isAuthenticated } = useAuthContext();
  const location = useLocation();

  if (location.pathname === '/acceso-denegado') {
    return (
      <>
        <HeaderComponent />
        <AccesoDenegado />
        <FooterComponent />
      </>
    );
  }

  if (isAuthenticated === null) {
    return <div>Cargando autenticación...</div>; // o un spinner
  }

  return isAuthenticated ? <UserRutas /> : <AppRutas />;
}

function App() {
  useEffect(() => {
    window.addEventListener('error', (e) => {
      if (
        e.message ===
        'ResizeObserver loop completed with undelivered notifications.'
      ) {
        const overlay = document.getElementById(
          'webpack-dev-server-client-overlay'
        );
        const overlayDiv = document.getElementById(
          'webpack-dev-server-client-overlay-div'
        );
        if (overlay) overlay.style.display = 'none';
        if (overlayDiv) overlayDiv.style.display = 'none';
      }
    });
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
